import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export type AppLang = 'en' | 'ta';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly translate = inject(TranslateService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);

  readonly lang = signal<AppLang>('en');

  init(): void {
    const saved = this.readStored();
    this.use(saved);
  }

  use(lang: AppLang): void {
    this.lang.set(lang);
    this.translate.use(lang);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('appLang', lang);
      this.document.documentElement.lang = lang === 'ta' ? 'ta' : 'en';
    }
  }

  toggle(): void {
    this.use(this.lang() === 'en' ? 'ta' : 'en');
  }

  private readStored(): AppLang {
    if (!isPlatformBrowser(this.platformId)) return 'en';
    const raw = localStorage.getItem('appLang');
    return raw === 'ta' ? 'ta' : 'en';
  }
}
